import script from "./App.vue?vue&type=script&setup=true&lang=tsx"
export * from "./App.vue?vue&type=script&setup=true&lang=tsx"

const __exports__ = script;

export default __exports__